import { render } from "./AppPrivacyModal.vue?vue&type=template&id=00b50afc"
import script from "./AppPrivacyModal.vue?vue&type=script&lang=js"
export * from "./AppPrivacyModal.vue?vue&type=script&lang=js"

import "./AppPrivacyModal.vue?vue&type=style&index=0&id=00b50afc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__